import React from 'react';
import {LabelProps} from '../../interfaces/components/label';
import styled from 'styled-components/native';
import TextGeneric from '../textGeneric';
import {getByScreenSize} from '../../utils/responsive';
import {Pressable} from 'react-native';

/**
 * Styled component for the title of the label.
 */
const Title = styled(TextGeneric)`
  color: ${({theme}) => theme.text.dark};
  font-size: ${({theme}) => getByScreenSize(theme.text.s7, theme.text.s9)}px;
  margin-top: ${({theme}) => getByScreenSize(theme.text.s7, theme.text.s9)}px;
  margin-bottom: ${({theme}) =>
    getByScreenSize(theme.text.s7, theme.text.s9) / 2}px;
`;

/**
 * Styled component for the red container (for indicating required fields).
 */
const RedContainer = styled(TextGeneric)`
  color: ${({theme}) => theme.text.error};
`;

/**
 * Label component for displaying text with optional styling and indicators.
 *
 * @param {LabelProps} props - The Label component props.
 * @returns {React.ReactElement} The rendered Label component.
 */
const Label: React.FC<LabelProps> = ({
  label,
  labelStyle,
  isBold,
  isRequired,
  onPress,
  style,
}) => {
  return (
    <Pressable style={style} disabled={!onPress} onPress={onPress}>
      <Title suppressHighlighting={true} bold={isBold} style={labelStyle}>
        {isRequired && <RedContainer>* </RedContainer>}
        {label}
      </Title>
    </Pressable>
  );
};

export default Label;
